import React, { memo, useState } from 'react';

const CreateButton = ({
    name = 'New TrioClear Case',
    onClick = () => {},
    disabled = false,
    icon = '/img/createCase/createCaseIcon/button_icon1.png',
    iconWidth = 35,
    buttonBackgroundColor = undefined,
    displayFirstFitFlag = false,
    fixSize = true, // handle mobile size button in some senario need a fix size
}) => {
    const [hover, setHover] = useState(false);
    const buttonWidth = displayFirstFitFlag ? 490 : 380; // Adjust the width based on the displayFirstFitFlag
    const handleBackground = () => {
        if (disabled) {
            return 'linear-gradient(90deg, rgba(102,103,103,1) 0%, rgba(46,46,46,1) 100%)';
        } else {
            return hover
                ? 'linear-gradient(90deg, rgba(58,167,194,1) 0%, rgba(0,147,199,1) 100%)'
                : 'linear-gradient(90deg, rgba(102,103,103,1) 0%, rgba(46,46,46,1) 100%)';
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: buttonBackgroundColor ? buttonBackgroundColor : handleBackground(),
                color: 'white',
                padding: 4,
                borderRadius: 9999,
                maxWidth: buttonWidth,
                width: fixSize ? buttonWidth : '100%', // Full width by default
                minWidth: 200,
                cursor: !disabled && 'pointer',
                position: 'relative',
                opacity: disabled ? 0.5 : 1,
                userSelect: disabled ? 'none' : 'auto',
            }}
            onMouseEnter={disabled ? () => {} : () => setHover(true)}
            onMouseLeave={disabled ? () => {} : () => setHover(false)}
            onClick={disabled ? () => {} : onClick}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 9999,
                    maxWidth: buttonWidth,
                    minWidth: 200,
                    width: fixSize ? buttonWidth : '100%', // Full width by default
                    border: '1.5px solid white', // Add white border
                    paddingTop: !icon && 5,
                    paddingBottom: !icon && 5,
                }}
            >
                {icon && (
                    <img
                        src={icon}
                        style={{
                            width: iconWidth,
                            marginRight: 10, // Add space between the icon and the text
                        }}
                    />
                )}
                <div style={{ textAlign: 'center' }}>{name}</div>
            </div>
        </div>
    );
};

export default memo(CreateButton);
